import { render, staticRenderFns } from "./CarruselComp.vue?vue&type=template&id=71ed9f72&scoped=true&"
import script from "./CarruselComp.vue?vue&type=script&lang=js&"
export * from "./CarruselComp.vue?vue&type=script&lang=js&"
import style0 from "./CarruselComp.vue?vue&type=style&index=0&id=71ed9f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed9f72",
  null
  
)

export default component.exports